import React, { useCallback, useContext, useEffect, useState } from 'react'
import AdminSidebar from './AdminSidebar'
import AdminHeader from './AdminHeader'
import axios from 'axios';
import { AuthContext } from '../../../context/Authcontext';
const base_url = process.env.REACT_APP_API_URL;


const Bonus = () => {
   const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [redenvelope, setRedenvelope]= useState();
    const [permit, setPermit]= useState([]);
    const {getRoles}= useContext(AuthContext);
    const [formData, setFormData]= useState({
      money:'',
      noOfUser:'',
    });
    
      // Toggle sidebar visibility
      const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
      };

      const listRedenvelope= async()=> {
        const auth= localStorage.getItem('admin');
        const response= await axios.get(base_url + '/admin/manager/listRedenvelops',
          {
            headers:{
              'content-type': 'application/json',
              Authorization:`${auth}`,
            }
          }
        )

        // console.log('uhre',response);

          setRedenvelope(response?.data.redenvelopes);

      };

      // console.log('red',redenvelope);

      const fetchRoles= async ()=> {
        const auth= localStorage.getItem('admin');
        const role= localStorage.getItem('role');
      
        try{
          const roles= await getRoles(auth, role);
      
          roles.map((role)=>{
      
            const values= Object.values(role);
      
            values[0].map((val)=>{
      
              if(Object.keys(val).includes('bonus')){
                const permit= Object.values(val);
      
                setPermit(permit[0]);
              }
            })
            
          })
        }catch(error){
          console.log('ert',error);
        }
      }

      useEffect(()=> {
        listRedenvelope();
        fetchRoles();
      },[]);


      const handleChnage= (e)=> {
        const {name, value}= e.target;

        const validateValue= value.replace(/[^0-9]/g,'');
        console.log('name:', name , 'value:', validateValue);


        setFormData({
          ...formData,
          [name]:validateValue,
        });
      };

      const handleSubmit= async(e)=> {
        e.preventDefault();

        const auth= localStorage.getItem('admin');
        // console.log('auth',auth);
        const response= await axios.post(base_url + '/admin/manager/createBonus',
          formData,
          {
            headers:{
              'content-type':'application/json',
              Authorization:`${auth}`,
            }
          }
        )

        // console.log('repsssss',response);

        if(response?.data.success){
          alert("Code created Sucessfully");

          await listRedenvelope();
        }else{
          alert("Failed to create code");
        }
      }

      function formateT(params) {
        let result = (params < 10) ? "0" + params : params;
        return result;
      }
      function timerJoin(params = '', addHours = 0) {
        let date = '';
        if (params) {
          date = new Date(Number(params));
        } else {
          date = new Date();
        }
  
        date.setHours(date.getHours() + addHours);
  
        let years = formateT(date.getFullYear());
        let months = formateT(date.getMonth() + 1);
        let days = formateT(date.getDate());
  
        let hours = date.getHours() % 12;
        hours = hours === 0 ? 12 : hours;
        let ampm = date.getHours() < 12 ? "AM" : "PM";
  
        let minutes = formateT(date.getMinutes());
        let seconds = formateT(date.getSeconds());
  
        return years + '-' + months + '-' + days + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + ampm;
      }


      useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    return (
       <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1>Giftcode</h1>
          </div>
        </div>
      </div>
    </section>
    <div className={`container-fluid ${permit.includes('Create Bonus')?'d-block': 'd-none'}`}>
      <div className="card">
        <div className="row">
          <div className="col-md-12">
            <form style={{padding: '10px 20px'}} onSubmit={handleSubmit}>
              <div className="form-group money">
                <label htmlFor="money">Giftcode</label>
                <input type="text" className="form-control" id="money" name='money' placeholder="Enter the amount" value={formData.money} onChange={handleChnage}/>
              </div>
              <div className="form-group money">
                <label htmlFor="user">Users</label>
                <input type="text" className="form-control" id="user" name='noOfUser' placeholder="Enter the no of user" value={formData.noOfUser} onChange={handleChnage}/>
              </div>

              {/* <div className="form-group money">
                <div className="expiry_date_top">
                  <label htmlFor="expiry_date">Expiry Date</label>
                  <input type="checkbox" className="checkbox_expiry" id="expiry_date_check" />
                </div>
                <input type="datetime-local" className="form-control" id="expiry_date" placeholder="Enter the no of user" onChange={handleChnage}/>
              </div>

              <div className="d-flex gap-2 form-group money checkbox_field">
              <input type="checkbox" className="checkbox" id="isForNewUsers" />
                <label htmlFor="isForNewUsers">Only New Users</label>
                
              </div>
              <div className="form-group result" style={{display: 'none'}}>
                <input type="text" className="form-control" id="money_result" placeholder="Link" />
                <div className="input-group-text copy_link">
                  <i className="fa fa-clone" aria-hidden="true" />
                </div>
              </div> */}
              <button type="submit" className='btn btn-danger' id="submit" style={{width: '100%', marginTop: 26}}>Create</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div className="mb-4" />
    <section className={`content ${permit.includes('Read Bonus')?'d-block': 'd-none'}`}>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Gift code has not been used yet</h3>
          <div className="card-tools">
            <button type="button" className="btn btn-tool" data-card-widget="collapse" title="Collapse">
              <i className="fas fa-minus" />
            </button>
            <button type="button" className="btn btn-tool" data-card-widget="remove" title="Remove">
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <div className="card-body p-0" style={{display: 'block', overflowY: 'hidden'}}>
          <table className="table table-striped projects" id="table1">
            <thead>
              <tr>
                <th className="text-center">ID</th>
                <th className="text-center">Creator</th>
                <th className="text-center">Gift code Amount</th>
                <th className="text-center">Users</th>
                {/* <th className="text-center">New users Only</th>
                <th className="text-center">Expiry</th> */}
                <th className="text-center">Time</th>
              </tr>
            </thead>
            <tbody id="list-details-news">
            {redenvelope?.map((list)=> (
                  <tr key={list.id}>
                    <td className='text-center'>{list.id}</td>
                    <td className='text-center'>{list.phone}</td>
                    <td className='text-center'>{list.money}</td>
                    <td className='text-center'>{list.used}</td>
                    <td className='text-center'>{timerJoin(list.time)}</td>
                  </tr>
                ))}
            </tbody>
                
          </table>
        </div>
      </div>
    </section>
  </div>
</div>

    )
}

export default Bonus